var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3769_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8061 1.9438C6.93202 1.55433 5.95547 1.45785 5.02209 1.66874C4.0887 1.87962 3.24849 2.38658 2.62677 3.114C2.00504 3.84142 1.63511 4.75032 1.57215 5.70516C1.50919 6.66 1.75657 7.60961 2.27739 8.41237C2.79822 9.21513 3.56459 9.82802 4.4622 10.1596C5.35981 10.4913 6.34058 10.5238 7.25822 10.2525C8.17586 9.98121 8.98122 9.42053 9.55417 8.65411C10.1271 7.88777 10.4369 6.95679 10.4375 5.99999C10.4375 5.99989 10.4375 6.0001 10.4375 5.99999M10.4375 5.99999V5.53999C10.4375 5.22933 10.6894 4.97749 11 4.97749C11.3107 4.97749 11.5625 5.22933 11.5625 5.53999V5.99999C11.5618 7.1995 11.1734 8.36698 10.4552 9.32771C9.73701 10.2884 8.72748 10.9913 7.5772 11.3314C6.42691 11.6715 5.19751 11.6306 4.07233 11.2149C2.94715 10.7992 1.98649 10.031 1.33363 9.02468C0.68076 8.01841 0.370664 6.82805 0.449588 5.63114C0.528512 4.43423 0.992227 3.2949 1.77157 2.38306C2.55092 1.47123 3.60414 0.835747 4.77416 0.571396C5.94418 0.307046 7.1683 0.42799 8.26397 0.91619C8.54774 1.04263 8.67527 1.37517 8.54884 1.65893C8.4224 1.9427 8.08986 2.07024 7.8061 1.9438",
    fill: "#739900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3975 1.60205C11.6173 1.82161 11.6175 2.17777 11.3979 2.39755L6.39795 7.40255C6.29248 7.50813 6.14937 7.56746 6.00014 7.5675C5.85091 7.56754 5.70778 7.50827 5.60225 7.40275L4.10225 5.90275C3.88258 5.68308 3.88258 5.32692 4.10225 5.10725C4.32192 4.88758 4.67808 4.88758 4.89775 5.10725L5.9998 6.20931L10.6021 1.60245C10.8216 1.38267 11.1778 1.38249 11.3975 1.60205Z",
    fill: "#739900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3769_4576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStatus);
export default __webpack_public_path__ + "static/media/active-status.cc141574779d83eb5087780a529baea1.svg";
export { ForwardRef as ReactComponent };